<script setup lang="ts">
import { CheckoutFlowStep } from '@/composables/useCheckoutFlow';

const props = defineProps<{
  currentStep: any;
  isStepValid: boolean;
  goToNextStep: () => CheckoutFlowStep;
}>();
</script>

<template>
  <div class="sticky-next-step-container d-flex flex-column px-4">
    <v-row>
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="props.currentStep.value !== CheckoutFlowStep.ViewBolPage">
        <v-btn
          block
          append-icon="mdi-arrow-right"
          color="primary"
          :disabled="!props.isStepValid"
          @click="goToNextStep()">
          Next
        </v-btn>
      </v-col>
      <v-col v-else>
        <v-btn
          block
          append-icon="mdi-arrow-right"
          color="primary"
          :disabled="!props.isStepValid"
          @click="goToNextStep()">
          Sign BOL
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.sticky-next-step-container {
  position: sticky;
  bottom: 0;
  background: white;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
</style>
